import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IColorScheme, IColorSchemes } from '@interfaces/appearance';

export interface IColorSchemesState extends IColorSchemes {}

export const INITIAL_STATE: IColorSchemesState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
		totalItems: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class ColorSchemesStore {
	private _colorSchemesState = new BehaviorSubject<IColorSchemesState>(
		INITIAL_STATE
	);
	readonly colorSchemesState$ = this._colorSchemesState.asObservable();

	constructor() {}

	updateColorSchemes(colorSchemes: IColorSchemesState) {
		const state = this._colorSchemesState.value;

		const data = {
			...state,
			...colorSchemes,
		};

		this._colorSchemesState.next(data);

		return this._colorSchemesState.asObservable();
	}

	updateColorScheme(colorScheme: IColorScheme) {
		const state = this._colorSchemesState.value;

		const colorSchemeIndex = state.result.findIndex(
			({ id }) => id === colorScheme.id
		);

		if (colorSchemeIndex >= 0) {
			state.result[colorSchemeIndex] = {
				...state.result[colorSchemeIndex],
				...colorScheme,
			};
		} else {
			state.result.push(colorScheme);
		}

		const data = state;

		this._colorSchemesState.next(data);

		return this._colorSchemesState.asObservable();
	}

	deleteColorScheme(colorScheme: IColorScheme) {
		const state = this._colorSchemesState.value;

		const colorSchemeIndex = state.result.findIndex(
			({ id }) => id === colorScheme.id
		);

		state.result.splice(colorSchemeIndex, 1);

		const data = state;

		this._colorSchemesState.next(data);

		return this._colorSchemesState.asObservable();
	}
}
